export default __webpack_public_path__ + "static/media/Asset 33.b103c52e.png";